import { Wrench, ArrowRight, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { useSiteSettings, useBranding } from "@/hooks/useCms";

export default function MaintenancePage() {
  const settings = useSiteSettings();
  const { logoLight } = useBranding();
  const title = settings.maintenance_title || "Estamos em manutenção";
  const message =
    settings.maintenance_message ||
    "O site está temporariamente indisponível para melhorias. Voltamos em breve.";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-50 via-white to-[#E6F6F8] px-6 py-16">
      <div className="max-w-lg w-full text-center">
        <img src={logoLight} alt="INXPEK" className="h-10 mx-auto mb-10 object-contain" />
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#1698AC]/10 text-[#1698AC] mb-6">
          <Wrench size={28} />
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-medium text-slate-900 leading-tight mb-4">
          {title}
        </h1>
        <p className="text-slate-600 leading-relaxed mb-8 whitespace-pre-line">{message}</p>
        <a
          href="mailto:geral@inxpek.com"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-full bg-[#1698AC] text-white text-sm font-medium hover:bg-[#0F7484] active:scale-95 transition-all"
        >
          <Mail size={16} /> Contactar por email
        </a>
        <div className="mt-10 pt-6 border-t border-slate-200 text-xs text-slate-400">
          Área reservada?{" "}
          <Link to="/admin/login" className="text-[#1698AC] hover:underline inline-flex items-center gap-1">
            Aceder ao admin <ArrowRight size={12} />
          </Link>
        </div>
      </div>
    </div>
  );
}
